import { watch, type Ref } from 'vue';
import { focusWithRetry } from '@/utils/focus';

type ShipmentFormBodyFocusPort = {
  focusSection?: (name: 'tracker' | 'general' | 'stops') => boolean;
};

export function useShipmentEditFormFocus(options: {
  hydrated: Ref<boolean>;
  canEditTracker: Ref<boolean>;
  canEditMetadata: Ref<boolean>;
  formBodyRef: Ref<ShipmentFormBodyFocusPort | null>;
}) {
  async function focusFirstEditableField() {
    await focusWithRetry(() => {
      const body = options.formBodyRef.value;
      if (!body) return false;

      if (options.canEditTracker.value && body.focusSection?.('tracker')) {
        return true;
      }
      if (options.canEditMetadata.value && body.focusSection?.('general')) {
        return true;
      }
      return body.focusSection?.('stops') ?? false;
    });
  }

  watch(
    () => options.hydrated.value,
    (ready) => {
      if (!ready) return;
      void focusFirstEditableField();
    },
    { immediate: true },
  );
}
